<template>
    <div>
      <div id="preloader">
        <div id="loader" class="dots-fade">
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
      <div id="top">
        <div class="centered-container">
          <router-view></router-view>
        </div>
      </div>
    </div>
  </template>

<script>
export default {
  name: 'MobileLayout',
};
</script>

<style scoped>
.centered-container {
  justify-content: center;
  align-items: center;
  min-height: 80vh;
  padding: 20px;
  box-sizing: border-box;
}

header {
  background-color: #f8f9fa;
  padding: 10px;
  text-align: center;
}

main {
  padding: 20px;
}

footer {
  background-color: #f8f9fa;
  padding: 10px;
  text-align: center;
  position: fixed;
  bottom: 0;
  width: 100%;
}
</style> 